import changeTotalClassicAttachmentSize from './changeTotalClassicAttachmentSize';
import removeAttachmentFromWell from './removeAttachmentFromWell';
import AttachmentWellViewState from '../schema/AttachmentWellViewState';
import { AttachmentFullViewState } from 'owa-attachment-full-data';
import { refreshSharingTipsForAttachment } from 'owa-attachment-model-store';
import { trace } from 'owa-trace';
import { action } from 'satcheljs/lib/legacy';

export default action('replaceAttachmentInWell')(function replaceAttachmentInWell(
    attachmentWell: AttachmentWellViewState,
    oldAttachment: AttachmentFullViewState,
    newAttachment: AttachmentFullViewState,
    newAttachmentSize: number
) {
    let index = attachmentWell.docViewAttachments.indexOf(oldAttachment);
    if (index > -1) {
        removeAttachmentFromWell(attachmentWell, oldAttachment);
        attachmentWell.docViewAttachments.splice(index, 0, newAttachment);
    } else if ((index = attachmentWell.imageViewAttachments.indexOf(oldAttachment)) > -1) {
        removeAttachmentFromWell(attachmentWell, oldAttachment);
        attachmentWell.imageViewAttachments.splice(index, 0, newAttachment);
    } else {
        trace.error("Can't find the oldAttachment when invoking replaceAttachmentInWell");
    }

    if (!newAttachment.isCloudy) {
        changeTotalClassicAttachmentSize(attachmentWell, newAttachmentSize);
    }
    refreshSharingTipsForAttachment(newAttachment.attachmentId);
});
